import { cn } from '../utils';

/**
 * Cornice browser leggera attorno a uno screenshot reale del prodotto.
 * Serve alla landing e al pannello di accesso: niente illustrazioni
 * generiche, solo il prodotto vero.
 */
export default function CorniceBrowser({
  src,
  alt,
  indirizzo = 'dimora.local/landlord',
  className,
  eager = false
}) {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-xl border border-border bg-card shadow-xl',
        className
      )}
    >
      <div className="flex items-center gap-1.5 border-b border-border bg-muted px-4 py-2.5">
        <span className="size-2.5 rounded-full bg-[#FCA5A5]" />
        <span className="size-2.5 rounded-full bg-[#FCD34D]" />
        <span className="size-2.5 rounded-full bg-[#86EFAC]" />
        <span className="ml-3 hidden max-w-xs flex-1 truncate rounded-md border border-border bg-background px-3 py-0.5 text-left text-[11px] leading-4 text-muted-foreground sm:block">
          {indirizzo}
        </span>
      </div>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={src}
        alt={alt}
        className="block w-full"
        loading={eager ? 'eager' : 'lazy'}
      />
    </div>
  );
}
